// @ts-check
/**
 * Interface for Adyen Apple Pay strategy.
 * @typedef {Object} AdyenApplePayStrategy
 * @property {function(Object): Promise<Object>} createPayload - Create payment payload.
 */

/**
 * Adyen Apple Pay strategy.
 * @function AdyenApplePayStrategy
 * @returns {AdyenApplePayStrategy}
 */
const AdyenApplePayStrategy = () => {
  /**
   * Create a payload for Adyen Apple Pay.
   * Apple Pay is PSD2 SCA-compliant through Face ID/Touch ID authentication,
   * so no additional browserInfo or 3DS handling is required.
   * @param {Object} applePayData - The data received from Apple Pay component (state.data from onSubmit).
   * @param {Object} applePayData.paymentMethod - Payment method object from Adyen.
   * @param {string} applePayData.paymentMethod.type - Payment method type ('applepay').
   * @param {string} applePayData.paymentMethod.applePayToken - Base64-encoded Apple Pay token.
   * @returns {Promise<Object>} The payload formatted for the backend.
   */
  const createPayload = async (applePayData) => {
    return {
      apple_pay_data: {
        paymentMethod: applePayData.paymentMethod,
      },
    };
  };

  return { createPayload };
};

const adyenApplePayStrategy = AdyenApplePayStrategy();

export default adyenApplePayStrategy;
